import { render } from "./VideocallList.vue?vue&type=template&id=63b8bfd8&scoped=true"
import script from "./VideocallList.vue?vue&type=script&lang=js"
export * from "./VideocallList.vue?vue&type=script&lang=js"

import "./VideocallList.vue?vue&type=style&index=0&id=63b8bfd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b8bfd8"]])

export default __exports__